"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningProjects = exports.ClonedLearningProject = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
/**
 * Represents a cloned learning project.
 *
 * @property {string} fromProjectUid - The unique identifier of the original project from which this project was cloned.
 * @property {string} clonedProjectUid - The unique identifier of the cloned project.
 * @property {Date} clonedOn - The date and time when the project was cloned.
 */
exports.ClonedLearningProject = zod_1.default.object({
    fromProjectUid: zod_1.default.string(),
    clonedProjectUid: zod_1.default.string(),
    clonedOn: zod_1.default.number(),
});
exports.LearningProjects = zod_1.default.object({
    hide: zod_1.default.boolean(),
    projects: zod_1.default.record(zod_1.default.string(), exports.ClonedLearningProject),
});
//# sourceMappingURL=learningProject.js.map